window.slate = window.slate || {};
window.theme = window.theme || {};

var passiveSupported = false;
var slideIndex = 0;
var carouselMarginLeft = 0;
const BASIC_MEMBERSHIP_TYPE = 'basic';
var membershipActiveType = BASIC_MEMBERSHIP_TYPE;
var membershipSlides = { basic: [], extra: [] };
var defaultSlideLineHeight = 29; //px
var membershipTimeout;
var startXScroll = 0;
var startYScroll = 0;
var scroll = 0;
var scrollSpeed = 15;

try {
  var options = {
    get passive() { // This function will be called when the browser
                    //   attempts to access the passive property.
      passiveSupported = true;
      return false;
    }
  };

  window.addEventListener("test", null, options);
  window.removeEventListener("test", null, options);
} catch(err) {
  passiveSupported = false;
}

window.theme.Support = {
  passiveSupported: passiveSupported,
  animate: typeof Element.prototype.animate === 'function'
}

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    
   
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: JSON.parse($("[data-product-json]").html())
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featured_image.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});


/**
 * Tabs.
 * @return {Array} public API.
 */
(function Tabs() {
  'use strict';
  
  var instances = $.makeArray($('[data-tabs]'));
  var init = compose(setEvents, collateData);

  var publicAPI = instances.map(init);
  theme.Tabs = publicAPI;
  return publicAPI;

  // **************************

  /**
   * Get elements.
   * @param {HTMLElement} trigger Button with data-js-collapsible attribute.
   * @return {Object} Object with instance data.
   */
  function collateData(instance) {
    return {
      instance: instance,
      triggers: $.makeArray(instance.querySelectorAll('[role="tab"]')),
      panels: $.makeArray(instance.querySelectorAll('[role="tabpanel"]'))
    };
  }

  /**
   * Add 'click' events.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function setEvents(obj) {
    obj.triggers.forEach(function setEvent(trigger) {
      var panel = obj.instance.querySelector('#' + trigger.getAttribute('aria-controls'));
      trigger.addEventListener('click', partial(expand, obj, trigger, panel));
    });

    return obj;
  }

  /**
   * Expand panel.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function expand(obj, trigger, panel) {
    obj.panels.map(function(instancePanel) {
      return instancePanel.id === panel.id 
      	? { panel: instancePanel, direction: 'reverse' } 
      	: { panel: instancePanel, direction: 'normal' };
    });

    obj.panels.forEach(function setPanelState(instancePanel) {
      instancePanel.id === panel.id 
      	? instancePanel.removeAttribute('hidden') 
      	: instancePanel.setAttribute('hidden', true);
    });

    obj.triggers.forEach(function setTriggerState(instanceTrigger) {
      instanceTrigger.id === trigger.id 
      	? instanceTrigger.setAttribute('aria-selected', true) 
      	: instanceTrigger.setAttribute('aria-selected', false);
      
      instanceTrigger.id === trigger.id 
      	? instanceTrigger.removeAttribute('tabindex', true) 
      	: instanceTrigger.setAttribute('tabindex', '-1');
    });

    return obj;
  }
})();


/**
 * Tooltips.
 */
(function Tooltips() {
  'use strict';
  
  var $tooltipButtons = $('[data-tooltip-button]');
  var $tooltipItems = $('[data-tooltip-content]');
  
  $tooltipButtons.on('click', interaction);
  
  function interaction() {
    var index = $(this).attr('data-tooltip-button');
    
    $tooltipButtons.removeAttr('data-tooltip-active');
    $(this).attr('data-tooltip-active', true);
    
    $tooltipItems.removeAttr('data-tooltip-active');
    $tooltipItems.eq(index).attr('data-tooltip-active', true);
  }
})();


/**
 * Tooltips.
 */
(function ScrollTo() {
  'use strict';
  
  var $triggers = $('[data-scroll]');
  var header = document.getElementById('shopify-section-header');
  
  $triggers.on('click', scrollToTarget);
  
  function scrollToTarget(evt) {
    if (!header) return;

    var targetFragment = evt.currentTarget.getAttribute('href').split('#');
    var targetElement = document.getElementById(targetFragment[targetFragment.length - 1]);
    
    if (targetElement) {
      evt.preventDefault();
      
      var targetElementTop = targetElement.getBoundingClientRect().top;
      var headerHeight = header.getBoundingClientRect().height;

      window.scrollTo({
        top: targetElementTop - headerHeight + window.scrollY,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
})();


/**
 * Mobile Navigation.
 */
(function MobileNavigation() {
  'use strict';
  
  $('[data-mobile-drawer-link]').on('click', closeCollapsible);
  
  function closeCollapsible() {
    theme.Collapsible.forEach(function(collapsible){
      collapsible.collapse();
    });
  }
})();


/**
 * Video Autoplay.
 * @return {Array} public API.
 */
(function VideoAutoplay() {
  'use strict';
  
  if (typeof IntersectionObserver !== 'function') return;
  
  var videos = $.makeArray($('[data-video-autoplay]'));
  
  var options = {
    rootMargin: '0px',
    threshold: 1.0
  }

  var observer = new IntersectionObserver(callback, options);
  
  videos.forEach(function(video){
    observer.observe(video);
  })
  
  function callback(entries, observer) {
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        entry.target.play();
        observer.unobserve(entry.target);
      } 
    })
  }
  
})();


(function DynamicCart() {
  'use strict';

  var cartContainer = document.querySelector('[data-cart-drawer]');
  var $openBtn = $('[data-cart-open]');
  var $closeBtn = $('[data-cart-close]');
  var $productForm = $('form[action="/en/cart/add"], form[action="/cart/add"]');
  
  if (!$openBtn.length) return;

  $openBtn.on('click', openCart);
  $closeBtn.on('click', closeCart);
  $productForm.on('submit', openCart);
  
  function openCart(evt) {
    var evtOrCart = evt;
    
    if (evtOrCart && typeof evtOrCart.preventDefault === 'function') {
      evtOrCart.preventDefault();
    }

    cartContainer.setAttribute('data-cart-visibile', true);
  }
  
  function closeCart(evt) {
    evt.preventDefault();
    cartContainer.removeAttribute('data-cart-visibile');
  }
})();



/**
 * Tabs.
 * @return {Array} public API.
 */
(function Sliders() {
  'use strict';
  
  var instances = $.makeArray($('[data-js-slider]'));
  var init = compose(scrollStop, setInitialPosition, setEvents, setDimensions, setControlState, getMetrics, collateData);
  
  var scrollTimer;

  var publicAPI = instances.map(init);
  theme.Sliders = publicAPI;
  return publicAPI;

  // **************************
  

  /**
   * Get elements.
   * @param {HTMLElement} instance.
   * @return {Object} Object with instance data.
   */
  function collateData(instance) {
    return {
      container: instance,
      slides: $.makeArray(instance.querySelectorAll('[data-slide]')),
      track: instance.querySelector('[data-track]'),
      scrollbar: instance.querySelector('[data-scrollbar]'),
      scrollbarOverflow: instance.querySelector('[data-scrollbar-overflow]'),
      sliderContentUpdate: instance.querySelector('[data-slider-update]'),
      controlPrev: instance.querySelector('[data-slider-control="prev"]'),
      controlNext: instance.querySelector('[data-slider-control="next"]'),
      wrap: instance.querySelector('[data-slider-wrap]'),
      indicator: instance.querySelector('[data-scroll-indicator]'),
      slider3d: instance.querySelector('[data-slider-3d]'),
      initialPosition: Number(instance.getAttribute('data-slider-position')),
      controlBtns: $.makeArray(instance.querySelectorAll('[data-goto-slide]'))
    };
  }
  
  /**
   * Add events.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function setEvents(obj) {    
 
    var throttleSliderScroll = throttle(partial(trackScroll, obj), 16);
    var throttleResize = throttle(partial(compose(setDimensions, trackScroll, setControlState, getMetrics), obj), 66);
    var passive = theme.Support.passiveSupported ? { passive: true } : false;
    
    window.addEventListener('resize', throttleResize);
    obj.controlPrev.addEventListener('click', partial(goToSlide, obj));
    obj.controlNext.addEventListener('click', partial(goToSlide, obj));
    obj.track.addEventListener('scroll', throttleSliderScroll, passive);
    obj.track.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(partial(scrollStop, obj), 64);
    }, passive);
    
    obj.controlBtns.forEach(function(btn, index){
      btn.addEventListener('click', partial(goToSlideNo, index, obj));
    });

    return obj;
  }
  
  function setInitialPosition(obj) {
    if (!obj.initialPosition) obj;
    
    obj.track.scrollLeft = obj.initialPosition * obj.metrics.slideBox.width;
    return obj;
  }
  
  function setDimensions(obj) {
    obj.indicator.style.width = 100 / obj.slides.length + '%';
    return obj;
  }
  
  function getMetrics(obj) {
    var slideBox = head(obj.slides).getBoundingClientRect();
    var containerBox = obj.container.getBoundingClientRect();
    var firstSlideMargin = parseInt(window.getComputedStyle(head(obj.slides)).marginLeft, 10);
    var lastSlideMargin = parseInt(window.getComputedStyle(last(obj.slides)).marginRight, 10);
    var totalWidth = obj.slides.length * slideBox.width + firstSlideMargin + lastSlideMargin;
    var maxScroll =  totalWidth - containerBox.width;
    
    obj.metrics = {
      containerBox: containerBox,
      slideBox: slideBox,
      totalWidth: totalWidth,
      maxScroll: maxScroll
    }
    
    return obj;
  }
  
  function trackScroll(obj) { 
    var scroll = obj.track.scrollLeft;
    var metrics = obj.metrics;

    var progress = scroll / metrics.maxScroll;
    var x = progress * (obj.slides.length - 1);
    
    obj.indicator.style.transform = 'translateX(' + (100 * x) + '%)';
    if (obj.slider3d) obj.slider3d.style.transform = slider3dtransform(progress);
    
    return obj;
  }
  
  function goToSlide(obj) {
    var direction = this.getAttribute('data-slider-control');
    var slideWidth = head(obj.slides).getBoundingClientRect().width;
    var offset = direction === 'next' ? -slideWidth : slideWidth;
    var oldScroll = obj.track.scrollLeft;
    var newScroll = direction === 'next' ? oldScroll + slideWidth : oldScroll - slideWidth;
    var animationOptions = {
      duration: 240,
      easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      fill: 'none'
    }
    
    console.log(offset, newScroll)
    
    if (theme.Support.animate) {
      obj.wrap.animate(
        [
          { transform: 'translate3D(0px, 0, 0)' },
          { transform: 'translate3D(' + offset + 'px, 0, 0)' }
        ], animationOptions
      ).onfinish = function(){
        this.cancel();
        obj.track.scrollLeft = newScroll;
      }
      
      if (obj.slider3d) {
        var progressStart = oldScroll / obj.metrics.maxScroll;
        var progressEnd = newScroll / obj.metrics.maxScroll;
        
        obj.slider3d.animate(
          [
            { transform: slider3dtransform(progressStart) },
            { transform: slider3dtransform(progressEnd) }
          ], animationOptions
        ).onfinish = function(){
          obj.slider3d.style.transform = slider3dtransform(progressEnd);
          this.cancel();
        }
      }
    } else {
      obj.track.scrollLeft = newScroll
    } 
  }
  
  function goToSlideNo(index, obj) {
    var oldScroll = obj.track.scrollLeft;
    var slideWidth = head(obj.slides).getBoundingClientRect().width;
    var currentSlide = Number(oldScroll/slideWidth);
    var offset = slideWidth * (currentSlide - Number(index))
    var newScroll = slideWidth * index
    
    var animationOptions = {
      duration: 240,
      easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      fill: 'none'
    }
    
    if (theme.Support.animate) {
      obj.wrap.animate(
        [
          { transform: 'translate3D(0px, 0, 0)' },
          { transform: 'translate3D(' + offset + 'px, 0, 0)' }
        ], animationOptions
      ).onfinish = function(){
        this.cancel();
        obj.track.scrollLeft = newScroll;
      }
      
      if (obj.slider3d) {
        var progressStart = oldScroll / obj.metrics.maxScroll;
        var progressEnd = newScroll / obj.metrics.maxScroll;
        
        obj.slider3d.animate(
          [
            { transform: slider3dtransform(progressStart) },
            { transform: slider3dtransform(progressEnd) }
          ], animationOptions
        ).onfinish = function(){
          obj.slider3d.style.transform = slider3dtransform(progressEnd);
          this.cancel();
        }
      }
    } else {
      obj.track.scrollLeft = newScroll
    } 
  }
  
  function scrollStop(obj) {
    compose(partial(setContent, obj), getCenterSlide, setControlState)(obj);
    return obj
  }
  
  function setControlState(obj) {
    var scroll = obj.track.scrollLeft;
    
    obj.controlPrev.removeAttribute('disabled');
    obj.controlNext.removeAttribute('disabled');
    
    if (scroll === 0) obj.controlPrev.setAttribute('disabled', 'disabled');
    if (scroll === obj.metrics.maxScroll) obj.controlNext.setAttribute('disabled', 'disabled');

    return obj;
  }
  
  function slider3dtransform(progress) {
    return 'rotate3d(.3, 1, -0.178, 45deg) translate3d('+ (47 - (progress * 0.82 * 100)) + '%, -50px, -30px)';
  }
  
  function getCenterSlide(obj) {
    var trackBox = obj.track.getBoundingClientRect();
    var midX = (trackBox.right - trackBox.left) / 2;
    
    var i = 0;
    var il = obj.slides.length;
    var slide, slideBox;
    
    for (; i < il; i +=1) {
      slide = obj.slides[i];
      slideBox = slide.getBoundingClientRect();
      
      var l = slideBox.left - trackBox.left;
      var r = slideBox.right - trackBox.left;
          
      if (l <= midX && midX < r) {
        $(obj.slides).removeAttr('data-slide-active');
        $(slide).attr('data-slide-active', true);
        return slide;
        break;
      }
    }
  }
  
  function setContent(obj, target) {
    if (!obj.sliderContentUpdate) return;
    var contentEl = target.querySelector('[data-slider-content]');
    var content = contentEl.innerHTML;
    var videoPlayBtn = target.querySelector('[data-video-play]');
    
    if (obj.sliderContentUpdate.innerHTML !== content) obj.sliderContentUpdate.innerHTML = content;
    if (videoPlayBtn) videoPlayBtn.click();
  }
})();


/**
 * Collapsible.
 * @return {Array} public API.
 */
(function Collapsible() {
  var support = {
    WebAnimations: typeof Element.prototype.animate === 'function'
  }
  
  var triggers = $.makeArray($('[data-js-collapsible]'));
  var init = compose(exposeAPI, setEvents, collateData);

  var publicAPI = triggers.map(init);
  theme.Collapsible = publicAPI;
  theme.CollapsibleInit = init;
  return publicAPI;

  // **************************

  /**
   * Get elements.
   * @param {HTMLElement} trigger Button with data-js-collapsible attribute.
   * @return {Object} Object with instance data.
   */
  function collateData(trigger) {
    var instanceName = trigger.getAttribute('data-js-collapsible');
    
    return {
      trigger: trigger,
      panel: trigger.nextElementSibling,
      instanceName: instanceName,
      closeTrigger: document.querySelector('[data-js-close-collapsible="' + instanceName + '"]'),
    };
  }

  /**
   * Add 'click' events.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function setEvents(obj) {
    obj.trigger.addEventListener('click', partial(toggle, obj));
    
    if (obj.closeTrigger) {
      obj.closeTrigger.addEventListener('click', partial(toggle, obj));
    }
    return obj;
  }

  /**
   * Add 'collapse' and 'expand' methods to instance data.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function exposeAPI(obj) {
    return {
      collapse: partial(collapse, obj),
      expand: partial(expand, obj),
      isExpanded: partial(isExpanded, obj)
    };
  }

  /**
   * Toggle panel based on 'aria-expanded' attribute.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function toggle(obj) {
    isExpanded(obj) ? collapse(obj) : expand(obj);
    return obj;
  }

  /**
   * Expand panel.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function expand(obj) {
    obj.trigger.setAttribute('aria-expanded', true);
    obj.panel.removeAttribute('hidden');
    animate(obj.panel, 'normal');
    return obj;
  }

  /**
   * Collapse panel.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function collapse(obj) {
    obj.trigger.setAttribute('aria-expanded', false);
    obj.panel.setAttribute('hidden', true);
    animate(obj.panel, 'reverse');
    return obj;
  }

  /**
   * Instance expanded state.
   * @param {Object} obj Instance data.
   * @return {Boolean} Instance state.
   */
  function isExpanded(obj) {
    return obj.trigger.getAttribute('aria-expanded') === 'true' ? Boolean(true) : Boolean(false);
  }

  /**
   * Panel animation.
   * @param {HTMLElement} element Panel element to animate.
   * @param {String} direction Animation direction, normal or reverse.
   * @param {String} instanceName Collapsible instance name.
   * @return {undefined} Nothing to return.
   */
  function animate(element, direction) {
    if (!support.WebAnimations) return;

    element.setAttribute('data-is-animating', true);

    element.animate([{ height: 0 }, { height: element.offsetHeight + 'px' }], {
      duration: 180,
      fill: 'both',
      easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      direction: direction
    }).onfinish = function() {
      element.removeAttribute('data-is-animating');
      this.cancel();
    };
  }
})();



/**
 * Video Modal.
 * @return {Array} public API.
 */
(function VideoModal() {
  var triggers = $.makeArray($('[data-js-video-modal]'));
  var init = compose(exposeAPI, setEvents, collateData);

  var publicAPI = triggers.map(init);
  theme.VideoModal = publicAPI;
  return publicAPI;

  //* *************************

  /**
   * Get elements.
   * @param {HTMLElement} trigger Button with data-js-video-modal attribute.
   * @return {Object} Object with instance data.
   */
  function collateData(trigger) {
    return {
      trigger: trigger,
      src: trigger.getAttribute('data-js-video-modal')
    };
  }

  /**
   * Add 'click' events.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function setEvents(obj) {
    obj.trigger.addEventListener('click', partial(toggle, obj));
    return obj;
  }

  /**
   * Add 'collapse' and 'expand' methods to instance data.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function exposeAPI(obj) {
    return {
      trigger: obj.trigger,
      close: partial(close, obj),
      open: partial(open, obj)
    };
  }

  /**
   * Toggle panel based on 'aria-expanded' attribute.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function toggle(obj, evt) {
    evt.preventDefault();

    obj.trigger.getAttribute('aria-expanded') === 'true' ? close(obj) : open(obj);
    return obj;
  }

  function createMarkup(obj) {
    obj.container = document.createElement('div');
    obj.container.className = 'fixed z-4 top-0 left-0 w-full h-full bg-scrim';
    
    var isVimeo = obj.src.includes('vimeo.com/');

    if (isVimeo){ 
    obj.container.innerHTML =
      '<div class="ratio-16x9 w-full max-w-full abs-center" style="--aspect-ratio: 1.7777; max-height: 80vh; width: calc(80vh * 1.777);"> ' +
      '<iframe class="w-full max-w-16 absolute w-full h-full left-0 top-0" style="background: #000" src="' +
      obj.src +
      '" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>' +
      '<button type="button" class="absolute right-0" style="top: -40px; padding: 8px;" aria-label="close modal">' +
      '<img class="block" src="https://cdn.shopify.com/s/files/1/1391/7351/files/icon-close.svg?v=1590750920">' +
      '</button>' +
      '</div>';
    } else {
     obj.container.innerHTML =
      '<div class="ratio-16x9 w-full max-w-full abs-center" style="--aspect-ratio: 1.7777; max-height: 80vh; width: calc(80vh * 1.777);"> ' +
      '<video class="w-full max-w-16 absolute w-full h-full left-0 top-0" style="background: #000" src="' +
      obj.src +
      '" frameborder="0" allowfullscreen="" autoplay="1" allow="autoplay;" loop="true" controls></video>' +
      '<button type="button" class="absolute right-0" style="top: -40px; padding: 8px;" aria-label="close modal">' +
      '<img class="block" src="https://cdn.shopify.com/s/files/1/1391/7351/files/icon-close.svg?v=1590750920">' +
      '</button>' +
      '</div>';
    }

    obj.closeTrigger = obj.container.querySelector('button');
    return obj;
  }

  function appendMarkup(obj) {
    document.body.appendChild(obj.container)
    return obj;
  }

  function removeMarkup(obj) {
    document.body.removeChild(obj.container);
    return obj;
  }

  /**
   * Expand panel.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function open(obj) {
    compose(setCloseEvents, appendMarkup, createMarkup)(obj);
    obj.trigger.setAttribute('aria-expanded', true);
    return obj;
  }

  /**
   * Collapse panel.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function close(obj) {
    compose(removeMarkup, removeCloseEvents)(obj);
    obj.trigger.setAttribute('aria-expanded', false);
    return obj;
  }

  function setCloseEvents(obj) {
    obj.closeFn = partial(close, obj);
    obj.closeTrigger.addEventListener('click', obj.closeFn, true);
    window.addEventListener('keyup', obj.closeFn, true);
    return obj;
  }

  function removeCloseEvents(obj) {
    obj.closeTrigger.removeEventListener('click', obj.closeFn, true);
    window.removeEventListener('keyup', obj.closeFn, true);
    return obj;
  }

  function keyboardClose(obj, evt) {
    if (evt.key === 'Escape' || evt.key === 'Esc' || evt.keyCode === 27)
      obj.closeFn();
  }

  /**
   * Insert node after node.
   * @param {HTMLElement} newNode Node to be appended
   * @param {HTMLElement} referenceNode Refference node
   * @return {HTMLElement} newNode 
   */
  function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    return newNode;
  }
})();


(function VideoSection(){
  $('[data-video-play]').on('click', playVideo);
  var $videos = $('[data-section-video]');
  
  function playVideo() {
    var id = $(this).attr('data-video-play');
    var $video = $('#' + id);
    
    $videos.attr('hidden', 'hidden');
    $video.removeAttr('hidden');
    $video[0].play();
  }
})();


(function () {
  var Flip;

  Flip = class Flip {
    constructor(el) {
      this.el = el;
      this.el = $(this.el);
      this.currentStep = 0;
      $('.next').on('click', $.proxy(this.next, this));
    }

    next(event) {
      var currentStepEl, nextStepEl, nextStepNum;
      if (event) {
        event.preventDefault();
      }
      nextStepNum = this.currentStep + 1;
      currentStepEl = this.el.find(`.step${this.currentStep}`);
      nextStepEl = this.el.find(`.step${nextStepNum}`);
      if (nextStepEl.length) {
        currentStepEl.prev().removeClass('down');
        currentStepEl.removeClass('set');
        currentStepEl.addClass('down');
        nextStepEl.addClass('set');
        nextStepEl.removeClass('down');
        nextStepEl.next().removeClass('down');
        return this.currentStep++;
      } else {
        // reset to 0
        this.el.find(".step").removeClass('set');
        this.el.find(`.step${this.currentStep}`).addClass('down');
        this.el.find(".step").not(`.step${this.currentStep}`).removeClass('down');
        this.currentStep = -1;
        return this.next();
      }
    }};


  $(function() {
    var f;
    
    if (!document.getElementById('flipper')) return;
    
    f = new Flip(document.getElementById('flipper'));
    
    return setInterval(function () {
      return f.next();
    }, 1500);
  });

}).call(this);

(function CookieUtil() {
	'use strict';
  window.Vaha = window.Vaha || {};

  Vaha.Cookie = {
    read: readCookie,
    write: createCookie,
    erase: eraseCookie
  }

  /**
   * Cookie read util
   * @param {String} name Cookie name
   */
  function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

  /**
   * Cookie write util
   * @param {String} name
   * @param {String} value
   * @param {Number} days
   */
  function createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = '; expires=' + date.toGMTString();
    } else {
      var expires = ''; 
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  /**
   * Cookie erase util
   * @param {String} name
   */
  function eraseCookie(name) {
    createCookie(name, '', -1);
  }
})();


// Geo Redirect
(function geoRedirect() {
  var configEl = document.querySelector('[data-geo-redirect]');
  var shouldRun = (Vaha.Cookie.read('Vaha_georedirect_no_show') !== 'true');

  // Return if no config or cookie set
  if (shouldRun) init();

  function init() {
    var config = JSON.parse(configEl.innerHTML);
    var entitled = config.entitled;
    var panel = document.querySelector('[data-section-id="' + config.sectionId + '"]');
    var closeTriggers = panel.querySelectorAll('[data-georedirect-close]');

    /**
     * Panel close event init
     */
    closeTriggers.forEach(function(e){e.addEventListener('click', closePanel); });


    /**
     * API call
     */
    var req = new XMLHttpRequest();
    req.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) handleResponse(JSON.parse(this.response));
    }
    req.open('GET', 'https://geo.ipify.org/api/v1?apiKey=at_dqkuSERacsCPZBqNs6oREP6BOxJw6', true);
    req.send();

    /**
     * API response
     * @param {Object} response XMLHttpRequest response
     */
    function handleResponse(response) {
      if (entitled.indexOf(response.location.country) !== -1) showPanel(response.location.country);
    }


    /**
     * User panel close cookie set
     * Vaha.Cookie.write(name, value, days);
     */
    function setCloseCookie() {
      Vaha.Cookie.write('Vaha_georedirect_no_show', 'true', 365);
    }

    /**
     * Set panel visibility
     * Set close cookie
     * Animate panel state
     */
    function closePanel() {
      panel.setAttribute('hidden', 'hidden');
      setCloseCookie();
      animate(panel, 'reverse');
    }

    /**
     * Set new link HREF
     * Set panel visibility
     * Submit display event to GA
     * Animate panel state
     */
    function showPanel(countryCode) {
      panel.setAttribute('data-country', countryCode);
      panel.removeAttribute('hidden');
      animate(panel, 'normal');
    }

    /**
     * Animates collapsible panel
     * @param {DOMElement} element Element to be animated
     * @param {String} direction Animation direction
     */
    function animate(element, direction) {
      if (typeof document.body.animate !== 'function') return;

      element.setAttribute('data-is-animating', true);

      element.animate([{ height: 0 }, { height: panel.offsetHeight + 'px' }], {
        duration: 320,
        fill: 'both',
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        direction: direction
      }).onfinish = function() {
        this.cancel();
        element.removeAttribute('data-is-animating');
      };
    }
  }
})();


(function PassUTM() {
  'use strict';
  
  var $target = $('[data-utm]');
  
  try {
    if (!String.prototype.startsWith) {
      Object.defineProperty(String.prototype, 'startsWith', {
        value: function(search, rawPos) {
          var pos = rawPos > 0 ? rawPos | 0 : 0;
          return this.substring(pos, pos + search.length) === search;
        }
      });
    }

    var url = new URL(window.location.href);
    if (!url.search) return;
    
    var params = new URLSearchParams(url.search);
    
    var utm_params = [];
    params.forEach(function(value, key) {
      
      if (key.startsWith('utm_')) {
        utm_params.push(key + '=' + value);
      }
    });
    
    var utm_search = '?' + utm_params.join('&');
    
    if (utm_params.length) {
      var href = $target.attr('href');
      $target.attr('href', href + utm_search)
    }
  } catch (error) {
  	console.log(error)
  }
})();



function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last,
      deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date,
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}


/**
 * Returns the first element of the given list or string.
 * @param {Array} arr List
 * @example
 *   head(['fi', 'fo', 'fum']); //=> 'fi'
 * @return {*}
 */
function head(arr) {
  return arr[0];
}

function last(arr) {
  return arr[arr.length - 1];
}


/**
 * Gets all nodes with a given selector.
 * @param {String} str CSS selector string.
 * @param {HTMLElement|optional} root Optional root node.
 * @example
 *   nodeList('div') => [div,div,div]
 * @return {Array} Matched elements
 */
function nodeList(str, root) {
  var list;
  if (!root) root = document;
  list = root.querySelectorAll(str);
  return Array.prototype.slice.call(list);
}

/**
 * Partial Application
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 * @param {Function} fn
 * @return {Function} fn
 */
function partial(fn /* , args... */) {
  var slice = Array.prototype.slice;
  var args = slice.call(arguments, 1);
  return function() {
    return fn.apply(this, args.concat(slice.call(arguments, 0)));
  };
}

/**
 * Performs right-to-left function composition.
 * The rightmost function may have any arity, the remaining functions must be unary.
 * @example
 *   function plus1(n) {return n + 1};
 *   function plus2(n) {return n + 2};
 *   compose(plus2,plus1)(1) => 4
 * @return {Function} Composed function
 */
function compose() {
  var funcs = Array.prototype.slice.call(arguments).reverse();
  return function() {
    return funcs.slice(1).reduce(function(res, fn) {
      return fn(res);
    }, funcs[0].apply(undefined, arguments));
  };
}


/**
 * Get sale text and due date by current time.
 * @return { text: "sampleText", dueDate: 1605882254291 }
 */
function getSaleTextAndDueDate() {
    const blackWeekStartRange = new Date("Nov 20, 2020 00:00:00").getTime();
    const blackWeekEndRange = new Date("Nov 26, 2020 23:59:59").getTime();
    const blackFridayStartRange = new Date("Nov 27, 2020 00:00:00").getTime();
    const blackFridayEndRange = new Date("Nov 27, 2020 23:59:59").getTime();

    const cyberWeekStartRange = new Date("Nov 28, 2020 00:00:00").getTime();
    const cyberWeekEndRange = new Date("Dec 4, 2020 23:59:59").getTime();
    const currentDate = new Date().getTime();

    if (currentDate >= blackWeekStartRange && currentDate <= blackWeekEndRange) {
        return {
            "text": "++ Sichere dir jetzt das Premium Flow Set - nur in der Black Week kostenlos ++",
            dueDate: blackWeekEndRange
        };
    } else if (currentDate >= blackFridayStartRange && currentDate <= blackFridayEndRange) {
        return {
            "text": "++ Sichere dir jetzt das Premium Flow Set - nur in der Black Friday kostenlos ++",
            dueDate: blackFridayEndRange
        };
    } else if (currentDate >= cyberWeekStartRange && currentDate <= cyberWeekEndRange) {
        return {
            "text": "++ Sichere dir jetzt das Premium Flow Set - nur in der Cyber Week kostenlos ++",
            dueDate: cyberWeekEndRange
        };
    } else {
        return null;
    }
}

(function () {
    const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;


    const x = setInterval(function () {

        let sale = getSaleTextAndDueDate();
        if (!sale) {
            document.getElementById("countdown").style.display = "none";
            document.getElementById("banner-link").style.display = "none";
            document.getElementById("banner").style.display = "block";
            clearInterval(x);
        }
        const now = new Date().getTime();
        let countDown = sale.dueDate;
        const distance = countDown - now;

        document.getElementById("days").innerText = Math.floor(distance / (day));
        document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour));
        document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute));
        document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second);
        document.getElementById("banner-link").innerText = sale.text;

        if (distance < 0) {
            document.getElementById("countdown").style.display = "none";
            sale = getSaleTextAndDueDate();
            if (!sale) {
                document.getElementById("banner").style.display = "block";
                clearInterval(x);
            }
        }
    }, 0)
}());

function nextSlide(slideIncrementor) {
  showMembershipSlides(slideIndex + slideIncrementor);
}

function moveCarousel(slides) {
  const currentElementWidth = Math.round(slides[slideIndex].getBoundingClientRect().width * 100) / 100;
  const slideStyle = window.getComputedStyle(membershipSlides.basic[1]);
  const defaultMarginLeft = Math.round(slideStyle.getPropertyValue('margin-left').split('px')[0] * 100) / 100;
  const defaultMarginBySlideIndex = slideIndex > 1 ? Math.round((defaultMarginLeft * (slideIndex - 1)) * 100) / 100 : defaultMarginLeft;
  carouselMarginLeft = Math.round((currentElementWidth * slideIndex) * 100) / 100;
  
  if (carouselMarginLeft !== 0 && Math.abs(carouselMarginLeft) !== currentElementWidth * slides.length) {
    const margin = slideIndex > 1 ? `${-carouselMarginLeft - defaultMarginBySlideIndex}px` : `${-carouselMarginLeft}px`;
    slides[0].style.marginLeft = margin;
  } else {
    slides[0].style.marginLeft = `${defaultMarginLeft}px`;
  }
  
}

function showMembershipSlidesArrows(slides) {
  if (slideIndex === 0 && slides.length > 1) {
  	document.querySelector('.membership-prev').style.visibility = 'hidden';
    document.querySelector('.membership-next').style.visibility = 'visible';
    document.querySelector('.extraMembershipLink').style.display = 'none';
  } else if (slideIndex === 0 && slides.length <= 1) {
  	document.querySelector('.membership-prev').style.visibility = 'hidden';
    document.querySelector('.membership-next').style.visibility = 'hidden';
    document.querySelector('.extraMembershipLink').style.display = membershipActiveType === BASIC_MEMBERSHIP_TYPE ? 'block' : 'none';
  } else if (slideIndex === slides.length - 1) {
  	document.querySelector('.membership-prev').style.visibility = 'visible';
    document.querySelector('.membership-next').style.visibility = 'hidden';
    document.querySelector('.extraMembershipLink').style.display = 'block';
  } else {
  	document.querySelector('.membership-prev').style.visibility = 'visible';
    document.querySelector('.membership-next').style.visibility = 'visible';
    document.querySelector('.extraMembershipLink').style.display = 'none';
  }
}

function getVisibleIndex() {
  return membershipActiveType === BASIC_MEMBERSHIP_TYPE ? slideIndex : membershipSlides.basic.length + slideIndex;
}

function markActiveSlideTitle() {
  const titleLines = document.getElementsByClassName("membership-card-title-item-line");
  const visibleIndex = getVisibleIndex();
  
  for (let i = 0; i < titleLines.length; i++) {
    if (i === visibleIndex) {
      titleLines[i].style.visibility = 'visible';
    } else {
      titleLines[i].style.visibility = 'hidden';
    }
  }
}

function setOpacityForMembershipSlides(slides) {
  for (let i = 0; i < slides.length; i++) {
    if (i === slideIndex) {
      slides[i].style.opacity = "1";
    } else {
      slides[i].style.opacity = "0.5";
    }
  }
}

function updateCurrentSlideIndex(slideToShow, slides) {
  if (slideToShow === slides.length) {
  	slideIndex = 0;
    scrollOffset = 0;
  } else if (slideToShow < 0) {
    slideIndex = slides.length - 1;
  } else {
  	slideIndex = slideToShow;
  }
}

function getSlidesByActiveMembershipType() {
  return membershipSlides[membershipActiveType];
}

function getMembershipTitlesByActiveMembershipType() {
  const titles = document.getElementsByClassName("membership-card-title-item");
  let result = [];
  
  for (let i = 0; i < titles.length; i++) {
    if (!shouldHideTitle(titles[i].classList)) {
      result = [ ...result, titles[i] ];
    }
  }
  
  return result;
}

function showMembershipSlides(slideToShow) {
  if (slideToShow !== 5) {
    const slides = getSlidesByActiveMembershipType();

    updateCurrentSlideIndex(slideToShow, slides);
    setOpacityForMembershipSlides(slides);
    showMembershipSlidesArrows(slides);
    markActiveSlideTitle();
    showActiveSlides();
    moveCarousel(slides);
  }
}

function isActiveType(titleClasses) {
  return titleClasses.value.indexOf(membershipActiveType) >= 0;
}

function showActiveSlides() {
  const slides = document.getElementsByClassName("slide-item");
  
  for (let i = 0; i < slides.length; i++) {
    if (isActiveType(slides[i].classList)) {
      slides[i].style.display = 'flex';
    } else {
      slides[i].style.display = 'none';
    }
  }
}

function showActiveMembershipSideBar() {
  const titles = document.getElementsByClassName("membership-card-title-item");
  const extraMembershipIcon = document.getElementsByClassName("extra-membership-icon")[0];
  
  for (let i = 0; i < titles.length; i++) {
    if (isActiveType(titles[i].classList)) {
      titles[i].style.display = 'initial';
    } else {
      titles[i].style.display = 'none';
    }
  }
  
  if (membershipActiveType != BASIC_MEMBERSHIP_TYPE) {
  	extraMembershipIcon.style.display = 'block';
  } else {
    extraMembershipIcon.style.display = 'none';
  }
}

function updateActiveTabStyle() {
  const basicMembershipTab = document.getElementById("basicMembership");
  const extraMembershipTab = document.getElementById("extraMembership");
  
  if (membershipActiveType === BASIC_MEMBERSHIP_TYPE) {
    basicMembershipTab.classList.add("tab-selected");
    extraMembershipTab.classList.remove("tab-selected");
  } else {
    extraMembershipTab.classList.add("tab-selected");
    basicMembershipTab.classList.remove("tab-selected");
  }
}

function updateMembershipActiveType(type) {
  membershipActiveType = type;
  updateActiveTabStyle();
  showActiveMembershipSideBar();
  showMembershipSlides(0);
  buildSliderDots();
  setActiveDot();
}

function isBasicMembership(membership) {
  return membership.classList.value.indexOf(BASIC_MEMBERSHIP_TYPE) >= 0;
}

function setMembershipSlides() {
  const slides = document.getElementsByClassName("slide-item");
  
  for (let i = 0; i < slides.length; i++) {
    if (isBasicMembership(slides[i])) {
      membershipSlides = { 
        ...membershipSlides,
        basic: [ ...membershipSlides.basic, slides[i] ]
      }
    } else {
      membershipSlides = { 
        ...membershipSlides,
        extra: [ ...membershipSlides.extra, slides[i] ]
      }
    }
   }
}

function touchStart(event) {
  startXScroll = parseInt(event.touches[0].clientX);
  startYScroll = parseInt(event.touches[0].clientY);
}

function addScrollEventForSlides() {
  document.getElementsByClassName("carousel")[0].addEventListener("touchstart", touchStart, false);
//   jQuery(".carousel").on("touchmove", (event) => {
    
//     this.scrollTop = (parseInt(event.touches[0].clientY) - startYScroll);
//     if (membershipActiveType == BASIC_MEMBERSHIP_TYPE) {
//       const slides = getSlidesByActiveMembershipType();
//       const currentElementWidth = Math.round(slides[slideIndex].getBoundingClientRect().width * 100) / 100;
//       const slideStyle = window.getComputedStyle(membershipSlides.basic[0]);
//       const defaultMarginLeft = Math.round(slideStyle.getPropertyValue('margin-left').split('px')[0] * 100) / 100;
//       let distance = (parseInt(event.touches[0].clientX) - startXScroll) / scrollSpeed;
//       const direction = distance > 0 ? 1 : -1;
//       const maxDistanceAllowed = direction * scrollSpeed;
      
// //       if (direction === -1) {
// //         distance = distance < maxDistanceAllowed  ? maxDistanceAllowed : distance;
// //       } else {
// //       	distance = distance > maxDistanceAllowed ? maxDistanceAllowed : distance;
// //       }

// //       scroll += (-1 * distance);
// //       const maximumScroll = (slides.length - 1) * currentElementWidth + (slides.length - 2) * defaultMarginLeft;
      

//       slideIndex = Math.round(scroll / currentElementWidth);
// //       for (let i = 0; i < slides.length; i++) {
// //         if (slideIndex !== 0 && scroll >= maximumScroll) {
// //           scroll = maximumScroll;
// //         } else if (-scroll > 0) {
// //           scroll = 0;
// //         }
// //         slides[i].style.transform = `translateX(${-scroll}px)`;
// //       }
//       setOpacityForMembershipSlides(slides);
//       setActiveDot();
//     }
//   });
  
  document.getElementsByClassName("carousel")[0].addEventListener("scroll", function (event) {
    const slides = getSlidesByActiveMembershipType();
    const currentElementWidth = Math.round(slides[slideIndex].getBoundingClientRect().width * 100) / 100;
    const slideStyle = window.getComputedStyle(membershipSlides.basic[0]);
    const defaultMarginLeft = Math.round(slideStyle.getPropertyValue('margin-left').split('px')[0] * 100) / 100;
    const leftScroll = Math.round(this.scrollLeft);

    slideIndex = Math.round(leftScroll / currentElementWidth);
    setOpacityForMembershipSlides(slides);
    setActiveDot();
  });
}

function setActiveDot() {
  const dots = document.getElementsByClassName("dot");
  
  for (let i = 0; i < dots.length; i++) {
    if (i === slideIndex) {
      dots[i].classList.add('active');
    } else {
      dots[i].classList.remove('active');
    }
  }
}

function updateOffsetSettings(slides) {
  const currentElementWidth = Math.round(slides[slideIndex].getBoundingClientRect().width * 100) / 100;
  const slideStyle = window.getComputedStyle(membershipSlides.basic[0]);
  const defaultMarginLeft = Math.round(slideStyle.getPropertyValue('margin-left').split('px')[0] * 100) / 100;
  let scrollValue = Math.round((slideIndex * (currentElementWidth + defaultMarginLeft)) * 100) / 100;
  scrollValue = slideIndex === 0 ? slideIndex * currentElementWidth : scrollValue;
  
//   for (let i = 0; i < slides.length; i++) {
//     slides[i].style.transform = `translateX(${-scrollValue}px)`;
//   }
//   scroll = scrollValue;
  document.getElementsByClassName("carousel")[0].scrollLeft = scrollValue;
}

function scrollToSlide(slideToShow, slides) {
  slideIndex = slideToShow;
  updateOffsetSettings(slides);
  setOpacityForMembershipSlides(slides);
  setActiveDot();
}

function addSlideDots() {
  const dotsContainer = document.querySelector('.dots-container');
  const slides = getSlidesByActiveMembershipType();
  
  for (let i = 0; i < slides.length; i++) {
  	const dot = document.createElement('span');
  	dot.classList.add('dot');
    dot.addEventListener('click', () => {
      scrollToSlide(i, slides);
    });
    dotsContainer.appendChild(dot);
  }
  
}

function restoreDots() {
  document.querySelector('.dots-container').innerHTML = '';
}

function buildSliderDots() {
  restoreDots();
  addSlideDots();
}

function setSlideLineTop() {
  if (window.innerWidth < 576) {
    const imageStyle = window.getComputedStyle(document.getElementsByClassName("membership-image")[0]);
    const imageHeight = Math.round(imageStyle.getPropertyValue('height').split('px')[0]);
    const slideLines = document.getElementsByClassName("slide-item-line");

    for (let i = 0; i < slideLines.length; i++) {
      const line = slideLines[i];
      line.style.top = `${imageHeight - (defaultSlideLineHeight / 2)}px`;
      line.style.display = 'initial';
    }
  }
  
  clearTimeout(membershipTimeout);
}

function renderSliderLineOnResize() {
  window.addEventListener('resize', () => { membershipTimeout = setTimeout(setSlideLineTop, 100); });
}

function setupMembershipSection() {
  addScrollEventForSlides();
  setMembershipSlides();
  showActiveMembershipSideBar();
  showMembershipSlides(slideIndex);
  buildSliderDots();
  setActiveDot();
  membershipTimeout = setTimeout(setSlideLineTop, 100);
}


(function () {
  setupMembershipSection();
  renderSliderLineOnResize();
}());